export default __webpack_public_path__ + "static/media/Benefits (2).4c01dfe6.png";